import axios from 'axios'
import { param } from '../../../helpers/tools'
let settings = {
    baseUrl: null, 
    restUrl: null, 
    ecomUrl: null,
    ajaxUrl: null,
    adminUrl: null,
    appauth: null,
};

export default {
    setSettings({ baseUrl, restUrl, ecomUrl, ajaxUrl, adminUrl, appauth }) {
        settings = { baseUrl, restUrl, ecomUrl, ajaxUrl, adminUrl, appauth };
    },
    getSettings() {
        return settings;
    },

    removeFromCart(cartProductId) {
        return axios({
            method: 'POST',
            url: settings.restUrl + '/carts/my/products/' + cartProductId,
            withCredentials: true,
            data: {
                quantity: 0
            }
        })
    },
    
    deleteCartOrder() {
        return axios({
            method: 'DELETE',
            url: settings.restUrl + '/carts/my/order',
            withCredentials: true
        })
    },
    
    createMockReservation(data) {
        const status = 2;
        
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/reservations/order/${ status }`,
            withCredentials: true,
            data
        })
    },
    /**
     * Uses the same format as createMockReservation
     * @param {object} data 
     * @returns {Promise}
     */
    createCartPriceCheck(data) {        
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/carts/pricecheck/`,
            withCredentials: true,
            data
        })
    },

    activateOrder(orderId, hash) {
        const params = {
            orderId,
            hash,
        };
        let queryString = '';
        
        params.appauth = settings.appauth;

        if (Object.keys(params).length > 0) {
            queryString = '&'+param(params);
        }

        return axios({
            method: 'GET',
            url: `${ settings.ecomUrl }?action=activateorder${ queryString }`,
        })
    },

    getPaymentMethods() {
        const params = {};
        let queryString = '';
        
        params.appauth = settings.appauth;

        if (Object.keys(params).length > 0) {
            queryString = '&'+param(params);
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.ajaxUrl }/?getpaymentmethods=1${ queryString }`
        })
    },

    getAvailablePaymentMethods(start, end, productids = []) {
        const params = {
            start,
            end,
            productids
        }
        let queryString = '';
        
        params.appauth = settings.appauth;

        if (Object.keys(params).length > 0) {
            queryString = '&'+param(params);
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.ajaxUrl }/?publicpaymentmethods=1${ queryString }`
        })
    },

    // this is the old checkout no 5
    invoiceConfirmation(url, adminMode = false) {
        const params = {};
        let queryString = '';
        
        params.appauth = settings.appauth;

        if (adminMode) {
            params.noreceipt = 1;
        }

        if (Object.keys(params).length > 0) {
            queryString = '&'+param(params);
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.ecomUrl }${ url }${ queryString }`,
        })
    },

    getOrderInformation(orderId) {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/orders/${ orderId }`,
            withCredentials: true,
        })
    },

    handlePaymentMethod(orderId, selectedPaymentId) {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/orders/${ orderId }/pay/${ selectedPaymentId }`,
            withCredentials: true,
        })
    },

    createOrder(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/carts/my/checkout`,
            data,
            withCredentials: true,
        })
    },

    initRangeDispencer() {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/iot/rangedispencer/init/`,
            withCredentials: true
        })
    },

    useRangeDispencer(deviceId, accessControlId) {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/iot/rangedispencer/use/?deviceid=${ deviceId }&id=${ accessControlId }`,
            withCredentials: true
        })
    },

    submitGiftCard(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/carts/my/giftcards/`,
            data,
            withCredentials: true
        })
    },

    submitCoupon(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/carts/my/coupons/`,
            data,
            withCredentials: true
        })
    },

    useWallet(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/carts/my/wallet/use`,
            withCredentials: true,
            data,
        })
    },

    getWallet(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/carts/my/walletgetCheckout/`,
            withCredentials: true,
            data
        })
    },

    getGiftCards() {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/carts/my/giftcards/`,
            withCredentials: true
        })
    },

    getCoupons() {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/carts/my/coupons/`,
            withCredentials: true
        })
    },

    disableTime(data) {
        const status = 4;
        
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/reservations/order/${status}`,
            withCredentials: true,
            data
        })
    },
    
    disableTimeLegacy(data) {
        const params = {};
        let queryString = '';
        
        params.appauth = settings.appauth;

        if (Object.keys(params).length > 0) {
            queryString = '&'+param(params);
        }

        return axios({
            method: 'POST',
            url: settings.ajaxUrl + '?reservations=disabletime' + queryString,
            data
        })
    },
    
    addToCart(data) {
        return axios({
            method: 'POST',
            url: settings.restUrl + '/carts/my/products', //?action=addToCart
            withCredentials: true,
            headers: {
            },
            data
        })
    },
    
    getReservationProducts() {
        return axios({
            method: 'GET',
            url: settings.restUrl + '/products/?select=productid,meta,type,tickettype,price,benefitprice,trackinventory,maximum,visibility,active,manufacturer,dateofpublication,expirationdate,images&type=6',
            withCredentials: true,
        })
    },

    getProductInfo(productId) {
        return axios({
            method: 'GET',
            url: settings.restUrl + '/products/?select=productid,meta,type,price,maximum,visibility,active,manufacturer,images&productid='+productId,
            withCredentials: true,
        })
    },

    getProductUserInfo(productId) {
        const params = {
            productid: productId
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/initialization/?${ param(params) }`,
            withCredentials: true,
        })
    },
    
    // EcomReservation
    getReservationSettings(productId, date) {
        const params = {
            productid: productId,
            date
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/calendarsettings/?${ param(params) }`,
            withCredentials: true,
        })
    },

    getReservations(productId, date, weekMode = false, type = 1) {
        const params = {
            productid: productId,
            date
        };
        let queryString = '';
        
        if (weekMode) {
            params.week = 1;
        }

        if (type === 5) {
            params.golf = 1;
        }

        if (Object.keys(params).length > 0) {
            queryString = '?'+param(params);
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/${ queryString }`,
            withCredentials: true,

        })
    },
    
    // EcomReservation
    /**
     * 
     * @param {Array} resources - array of ids
     * @param {String} dateTimeStart - format 'YYYY-MM-DD HH:mm'
     * @param {String} dateTimeEnd - format 'YYYY-MM-DD HH:mm'
     * @param {String} nextTeeTime - format 'YYYY-MM-DD HH:mm'
     * @returns {Promise}
     */
    getResourceReservations(resources, dateTimeStart, dateTimeEnd, nextTeeTime = null) {
        const params = {
            resources,
            dateTimeStart,
            dateTimeEnd
        }

        if (nextTeeTime) {
            params.nextTeeTime = nextTeeTime
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/getresourcereservations/?${ param(params) }`,
            withCredentials: true,
        })
    },
    
    getMyCart() {
        return axios({
            method: 'GET',
            url: settings.restUrl + '/carts/my/products',
            withCredentials: true,
            headers: {
            }
        })
        .catch(() => ({ data: { rows: [], success: false } }))
    },
    
    deactivateReservationTime(reservationTimeId) {
        const data = {
            reservationtimeid: reservationTimeId
        }

        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/deactivatereservationtime/?${ param(data) }`,
            withCredentials: true,
        })
    },
    
    editReservationTime(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/reservations/edittime/`,
            data,
            withCredentials: true,
        })
    },
    // lite version of editReservationTime
    moveResourceTime(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/reservations/moveresource/`,
            data,
            withCredentials: true,
        })
    },

    getUserGolfReservations(params = {}) {
        let queryString = '';

        if (Object.keys(params).length > 0) {
            queryString = '?'+param(params);
        }

        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/getusergolfreservations/${ queryString }`,
            withCredentials: true,
        })
    },

    getUserReservations(params = {}) {
        let queryString = '';

        if (Object.keys(params).length > 0) {
            queryString = '?'+param(params);
        }

        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/getuserreservations/${ queryString }`,
            withCredentials: true,
        })
    },

    confirmTeeTime(reservationTimeId) {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/confirmgolfteetime/?reservationtimeid=${ reservationTimeId }`,
            withCredentials: true,
        })
    },

    // when an admin accidentally confirms a tee time, they want to cancel that action, not cancel the tee time
    cancelConfirmedTeeTime(reservationTimeId) {
        return axios({
            method: 'GET',            
            url: `${ settings.restUrl }/reservations/confirmgolfteetime/?reservationtimeid=${ reservationTimeId }&cancel=1`,
            withCredentials: true,
        })
    },

    setReservationSaleMode(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/reservations/setreservationsalemode/`,
            data,
            withCredentials: true,
        })
    },

    pushResourceComment(data) {
        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/reservations/pushresourcecomment/`,
            data,
            withCredentials: true,
        })
    },

    testProductOwnership(productId) {
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/reservations/productownership/?productid=${ productId }`,
            withCredentials: true,
        })
    },

    getShareOwners() {        
        return axios({
            method: 'GET',
            url: `${ settings.restUrl }/shareowners/`,
            withCredentials: true,
        })
    },
    
    requestAccessControl(passcode, personId = null, productId = null) {
        const params = {
            requestaccesscontrol: 1,
            passcode,
            appauth: settings.appauth
        }

        if (personId !== null && productId !== null) {
            params.personid = personId;
            params.productid = productId;
        }
        
        return axios({
            method: 'GET',
            url: `${ settings.ajaxUrl }?${ param(params) }`,
        })
    },

    submitAccessControlCode(code, orderProductId) {
        const data = {
            code,
        }

        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/orders/${ orderProductId }/multipurposeaccessright/`,
            data,
            withCredentials: true
        })
    },

    submitCouponCode(code, orderProductId) {
        const data = {
            code,
        }

        return axios({
            method: 'POST',
            url: `${ settings.restUrl }/orders/${ orderProductId }/productcoupons/`,
            data,
            withCredentials: true
        })
    },

    /**
     * @param {String} search
     * @param {Function} callback
     * @returns {Promise} 
     */
    searchPeople(search, companyIds = null) {
        const params = {
            controller: 'admin',
            action: 'listpersonsajax',
            appauth: settings.appauth
        }
        const data = {
            searchTerm: search,
            method: 'AllForNewOrderPage'
        }

        if (companyIds) {
            data.method = 'InCompanies';
            data.companyIds = companyIds;
        }

        return axios({
            method: 'POST',
            url: `${ settings.baseUrl }?${ param(params) }`,
            data,
        })
    },

    searchPersonById(personId) {
        const params = {
            controller: 'admin',
            action: 'listpersonsajax',
            appauth: settings.appauth
        }
        const data = {
            // it's an array but really uses just one
            // and for some reason it has to be json encoded x)
            personIds: JSON.stringify([ personId ]),
            method: 'AllForNewOrderPage'
        }

        return axios({
            method: 'POST',
            url: `${ settings.baseUrl }?${ param(params) }`,
            data,
        })
    },
    
    /**
     * @param {String} search
     * @returns {Promise} 
     */
    searchCompanies(search) {
        const params = {
            controller: 'admin',
            action: 'listcompaniesajax',
            appauth: settings.appauth
        }
        const data = {
            method: 'AllForNewOrderSelectBox2',
            searchTerm: search
        }
        return axios({
            method: 'POST',
            url: `${ settings.baseUrl }?${ param(params) }`,
            data,
        })
    },
}